import { render } from "./Paradorinf.vue?vue&type=template&id=38022c68&scoped=true"
import script from "./Paradorinf.vue?vue&type=script&lang=js"
export * from "./Paradorinf.vue?vue&type=script&lang=js"

import "./Paradorinf.vue?vue&type=style&index=0&id=38022c68&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38022c68"]])

export default __exports__